// extracted by mini-css-extract-plugin
export default {"adsCarousel":"AdsCarousel_adsCarousel__tUjo1","adImage":"AdsCarousel_adImage__8SKgk"};